/**
 * O schema do `tuninho:chart` no `StoreExtensionManager`.
 *
 * Arquivo NOSSO, em diretório NOSSO — a única linha que toca o upstream é a que o acrescenta
 * à lista em `manager/store.ts` (Regra 8.15).
 *
 * Sem isto, `Block` lança em `sync-controller.ts:295` (`schema for flavour not found`), o
 * `try/catch` de `store.ts:649` engole, e o bloco **não desenha**. O documento não quebra — é
 * a degradação segura da T3.4 — mas também não funciona, e é por isso que o registro existe.
 */

import {
  type StoreExtensionContext,
  StoreExtensionProvider,
} from '@blocksuite/affine/ext-loader';

import { TuninhoChartBlockSchemaExtension } from '../../blocks/tuninho-chart';

export class TuninhoStoreExtension extends StoreExtensionProvider {
  override name = 'tuninho-store-extensions';

  override setup(context: StoreExtensionContext) {
    super.setup(context);
    context.register(TuninhoChartBlockSchemaExtension);
  }
}
